export let config = {
  apiKey: "AIzaSyDGcZk_iu3LHPx42dJ4anUFHF9KVvALv5U",
  authDomain: "taorle.firebaseapp.com",
  databaseURL: "https://taorle.firebaseio.com",
  projectId: "taorle",
  storageBucket: "taorle.appspot.com",
  messagingSenderId: "927799389933",
  appId: "1:927799389933:web:3848ef57b8f737298de6e4",
  measurementId: "G-JXN7ZY81XF"
};  